export enum GridType {
    GENERIC = 'generic',
    RECORD = 'record'
}
